module.exports = __webpack_public_path__ + "img/breakfast_title--available.959d4694.png";